<!-- 管理者TOP -->
<template>
  <div>
    <HeaderComponent
      :external-pseudo-agent-code="pseudoAgCode"
      :external-pseudo-agent-name="pseudoAgName"
      :isAdminPage="true"
    />
  </div>
  <loading-overlay v-model:active="isLoading" :is-full-page="true" />
  <div v-if="isDataFetched" class="com_form_contet1">
    <section class="com_sec1">
      <div class="inner1">
        <h2 class="title_left">管理者TOP</h2>
        <!-- エラーメッセージの表示エリア -->
        <div v-if="formErrorMessage" class="error-message">
          {{ formErrorMessage }}
        </div>
        <!-- エラーメッセージの表示エリア -->
        <div v-if="errorMessage" class="error-message">
          {{ errorMessage }}
        </div>
        <div class="columns">
          <!-- エージェントコード切替 -->
          <div v-if="isKaunetAdmin">
            <fieldset class="agent-buttons" style="width: 550px">
              <legend>エージェントコード切替</legend>
              <!-- 半角英数のみ入力可能 -->
              <AlphanumericInput
                v-model="inputAgCode"
                maxlength="8"
                placeholder="エージェントコード"
              />
              <button
                type="button"
                name="btnPseudoLogin"
                class="button1"
                @click="pseudoLogin"
              >
                切替
              </button>
              <button
                type="button"
                name="btnPseudoLoginCancel"
                class="button1"
                @click="pseudoLoginCancel"
              >
                解除
              </button>
            </fieldset>
          </div>
          <!-- 営業日切替 -->
          <div v-if="isKaunetAdmin">
            <fieldset class="agent-buttons" style="width: 550px">
              <legend>営業日切替</legend>
              <input
                type="date"
                v-model="inputBusinessDays"
                :max="AppConstants.MAX_DATE_VALUE"
              />
              <button
                type="button"
                class="button1"
                @click="chengeBuisinessDate"
              >
                切替
              </button>
              <button type="button" class="button1" @click="clearBuisinessDate">
                解除
              </button>
            </fieldset>
          </div>
        </div>
        <div class="columns">
          <!-- ユーザー管理 -->
          <div v-if="isDispAgSegmentReg || isDispAgUserMaintenance">
            <fieldset class="agent-buttons" style="width: 550px">
              <legend>ユーザー管理</legend>
              <button
                v-if="isDispAgSegmentReg"
                type="button"
                name="btnLogout"
                class="button2"
                @click="agSegmentReg"
              >
                AGセグメント登録
              </button>
              <button
                v-if="isDispAgUserMaintenance"
                type="button"
                name="btnLogout"
                class="button2"
                @click="userMaintenance"
              >
                ユーザー情報管理
              </button>
            </fieldset>
          </div>
          <div v-if="isDispNoticeReg || isKaunetAdmin">
            <!-- お知らせ管理 -->
            <fieldset class="agent-buttons" style="width: 550px">
              <legend>お知らせ管理</legend>
              <button
                v-if="isDispNoticeReg"
                type="button"
                name="btnLogout"
                class="button2"
                @click="infoReg"
              >
                お知らせ登録
              </button>
              <button
                v-if="isKaunetAdmin"
                type="button"
                name="btnLogout"
                class="button2"
                @click="adminInfoReg"
              >
                管理者からのお知らせ登録
              </button>
            </fieldset>
          </div>
        </div>
        <!-- 3列目-->
        <div v-if="isDispSystemMaintenance && isKaunetAdmin">
          <fieldset class="agent-buttons" style="width: 1120px">
            <legend>システム管理</legend>
            <button
              v-if="isDispGlovalNaviKanri"
              type="button"
              name="btnGrovalNavi"
              class="button2"
              @click="globalNaviKanri"
            >
              グローバルナビ管理
            </button>
            <button
              v-if="isDispIconMenuKanri"
              type="button"
              name="btnIconMenu"
              class="button2"
              @click="iconMenuKanri"
            >
              アイコンメニュー管理
            </button>
            <button
              v-if="isDispLoginPopupKanri"
              type="button"
              name="btnLoginPopup"
              class="button2"
              @click="loginPopupTouroku"
            >
              ログイン時ポップアップ<br />管理
            </button>
            <button
              v-if="isDispBannerKanri"
              type="button"
              name="btnBanner"
              class="button2"
              @click="bannerTouroku"
            >
              バナー登録
            </button>
          </fieldset>
        </div>
        <!-- 4列目-->
        <div v-if="isKaunetAdmin && isDispOneStopGideKanri">
          <fieldset class="agent-buttons" style="width: 1120px">
            <legend>ワンストップガイド管理</legend>
            <button
              v-if="isDispFAQTouroku"
              type="button"
              name="btnFAQ"
              class="button2"
              @click="faqReg"
            >
              FAQ登録
            </button>
            <button
              v-if="isDispShinseisyoTouroku"
              type="button"
              name="btnShinseisyo"
              class="button2"
              @click="shinseisyoReg"
            >
              申請書登録
            </button>
            <button
              v-if="isDispTeiansyoTouroku"
              type="button"
              name="btnTeiansyo"
              class="button2"
              @click="teiansyoReg"
            >
              提案書登録
            </button>
            <button
              v-if="isDispManualTouroku"
              type="button"
              name="btnTyouhyou"
              class="button2"
              @click="manualReg"
            >
              帳票・マニュアル登録
            </button>
            <button
              v-if="isDispManualTouroku"
              type="button"
              name="btnTyouhyou"
              class="button2"
              @click="oneStopGideKanri"
            >
              ワンストップガイド<br />トップ管理
            </button>
          </fieldset>
        </div>
        <!-- 5列目-->
        <div v-if="isKaunetAdmin && isDispSkilupKanri">
          <fieldset class="agent-buttons" style="width: 800px">
            <legend>スキルアップ管理</legend>
            <button
              v-if="isDispSkilupTouroku"
              type="button"
              name="btnSkilUp"
              class="button2"
              @click="skilupReg"
            >
              スキルアップ登録
            </button>
            <button
              v-if="isDispEventTouroku"
              type="button"
              name="btnEvent"
              class="button2"
              @click="eventReg"
            >
              イベント登録
            </button>
            <button
              v-if="isDispEventEntryDL"
              type="button"
              name="btnEventDownload"
              class="button2"
              @click="eventEntryDL"
            >
              イベント申込み情報<br />ダウンロード
            </button>
          </fieldset>
        </div>
      </div>
    </section>
  </div>
  <div>
    <!-- フッタ -->
    <FooterComponent />
  </div>
</template>

<script lang="ts">
import { AxiosError } from "axios";
import { defineComponent, ref, onMounted, computed } from "vue";
import { formatMessage, outputDebugLogs, getLoginInfomation } from "@/Common";
import HeaderComponent from "../layout/HeaderComponent.vue";
import FooterComponent from "../layout/FooterComponent.vue";
import AlphanumericInput from "../controls/AlphanumericInput.vue";
import { useUserStore } from "../../store/userStore";
import { useProcessingStore } from "../../store/useProcessingStore";
import messages from "@/assets/messages.json";
import { AppConstants } from "@/constants/AppConstants";
import { useRouter } from "vue-router";
import apiAuthClient from "@/util/apiClientAuth";
import { useUserParmitionStore } from "@/store/userParmitionStore";
import LoadingOverlay from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";

interface Item {
  categoryId: string;
  parmitionFlg: boolean;
}

export default defineComponent({
  name: "AdminTopComponent",
  components: {
    HeaderComponent,
    FooterComponent,
    AlphanumericInput,
    LoadingOverlay,
  },
  setup() {
    const { setPseudoData } = useUserStore();
    const { removePseudoData } = useUserStore();
    const processingStore = useProcessingStore();
    const agCode = ref("");
    const userId = ref("");
    const inputAgCode = ref("");
    const pseudoAgCode = ref("");
    const pseudoAgName = ref("");
    const pseudoUserId = ref("");
    const pseudoDaihyoCode = ref("");
    const formErrorMessage = ref("");
    const errorMessage = ref("");
    const router = useRouter();
    const isKaunetAdmin = ref(false);
    const categoryListData = ref<Item[]>([]);
    const { getCategoryIdByName } = useUserParmitionStore();
    const inputBusinessDays = ref("");
    const isDataFetched = ref(false); // データが取得済みかどうかを追跡
    const isLoading = ref(false);

    // ********************
    // ***** 初期処理 *****
    // ********************
    onMounted(async () => {
      // 処理中フラグON
      processingStore.isProcessing = true;
      isLoading.value = true;

      try {
        // ローカルストレージからユーザー情報を取得して内部変数に展開
        const userInfo = localStorage.getItem(AppConstants.USER_SESSION_NAME);
        if (userInfo) {
          const parsedUserInfo = JSON.parse(userInfo);
          agCode.value = parsedUserInfo.agCode;
          userId.value = parsedUserInfo.userId;
          pseudoAgCode.value = parsedUserInfo.pseudoAgCode;
          pseudoUserId.value = parsedUserInfo.pseudoUserId;
          isKaunetAdmin.value =
            parsedUserInfo.isKaunet && parsedUserInfo.isAdmin;

          outputDebugLogs("管理者フラグ：" + parsedUserInfo.isKaunet);
          outputDebugLogs("カウネットフラグ：" + parsedUserInfo.isAdmin);
          outputDebugLogs("カウネット管理者：" + isKaunetAdmin.value);
        }

        const inputAgCode = ref("");
        const inputUserId = ref("");

        if (pseudoAgCode.value && pseudoAgCode.value.trim() !== "") {
          inputAgCode.value = pseudoAgCode.value;
        } else {
          inputAgCode.value = agCode.value;
        }

        if (pseudoUserId.value && pseudoUserId.value.trim() !== "") {
          inputUserId.value = pseudoUserId.value;
        } else {
          inputUserId.value = userId.value;
        }

        // 管理者カテゴリ取得API
        const response = await apiAuthClient.post(
          "/api/KanriTop/getKanriCategory",
          {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            agCode: inputAgCode.value,
            userId: inputUserId.value,
          }
        );
        categoryListData.value = response.data.categoryListData;
        outputDebugLogs(
          "管理者カテゴリリスト取得成功 件数：" + categoryListData.value.length
        );

        var businessDays = localStorage.getItem(
          AppConstants.BUSINESS_DAYS_SESSION_NAME
        );

        if (businessDays) {
          inputBusinessDays.value = businessDays.replace(/\//g, "-");
        } else {
          inputBusinessDays.value = new Date().toISOString().split("T")[0];
        }

        isDataFetched.value = true; // データが取得されたことを設定
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
        isLoading.value = false;
      }
    });

    /**
     * 疑似ログイン
     */
    const pseudoLogin = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }
      errorMessage.value = "";
      // 疑似ログインAGコード入力チェック
      if (!inputAgCode.value) {
        errorMessage.value = formatMessage(
          messages.ERR_0001,
          "エージェントコード"
        );
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        // 入力された疑似ログインAGコードとログインしているAGコードが同じ場合は
        // 疑似ログイン解除を行う
        if (inputAgCode.value == agCode.value) {
          // 疑似ログイン解除処理を行うために、処理中フラグを解除
          processingStore.isProcessing = false;
          pseudoLoginCancel();
          return;
        }

        // 疑似ログイン情報取得API
        const response = await apiAuthClient.post(
          "/api/KanriTop/changeAgCode",
          {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            agCode: agCode.value,
            userId: userId.value,
            pseudoLoginAgCode: inputAgCode.value,
            pseudoLoginId: inputAgCode.value, //AGコードと同じものを設定する
          }
        );

        if (!response.data.user.isSuccess) {
          // 疑似ログイン情報取得失敗
          outputDebugLogs("疑似ログイン情報取得失敗");
          errorMessage.value = formatMessage(
            messages.ERR_0006,
            "エージェントコード"
          );
          return;
        }

        outputDebugLogs("疑似ログイン情報成功");
        outputDebugLogs(
          "疑似ログインAGコード：" + response.data.user.pseudoLoginAgCode
        );
        outputDebugLogs(
          "疑似ログインAG名称：" + response.data.user.pseudoLoginAgName
        );
        outputDebugLogs(
          "疑似ログインユーザーID：" + response.data.user.pseudoLoginUserId
        );
        outputDebugLogs(
          "疑似ログイン代表コード：" + response.data.user.pseudoLoginDaihyoCode
        );
        outputDebugLogs("処理結果" + response.data.user.isSuccess);

        pseudoAgCode.value = response.data.user.pseudoLoginAgCode;
        pseudoUserId.value = response.data.user.pseudoLoginUserId;
        pseudoAgName.value = response.data.user.pseudoLoginAgName;
        pseudoDaihyoCode.value = response.data.user.pseudoLoginDaihyoCode;

        // ローカルストレージに疑似ログイン情報を設定
        setPseudoData(
          pseudoAgCode.value,
          pseudoAgName.value,
          pseudoUserId.value,
          pseudoDaihyoCode.value
        );

        outputDebugLogs("疑似ログイン");

        // 疑似ログインしたAGコードとユーザーIDでグローバルナビや権限情報などを取得
        const error = await getLoginInfomation(
          pseudoAgCode.value,
          pseudoUserId.value,
          true
        );

        if (error) {
          formErrorMessage.value = error;
          return;
        } else {
          formErrorMessage.value = "";
        }

        // 画面をリロード
        location.reload();
      } catch (error: unknown) {
        const axiosError = error as AxiosError;
        if (axiosError.response) {
          switch (axiosError.response.status) {
            case 500:
              errorMessage.value = messages.ERR_SYS998;
              break;
            default:
              errorMessage.value = messages.ERR_SYS001;
          }
        } else if (axiosError.request) {
          errorMessage.value = messages.ERR_SYS001;
        } else {
          errorMessage.value = messages.ERR_SYS002;
          if (process.env.VUE_APP_DEBUG === "true") {
            console.log("Error: ", axiosError.message);
          }
        }
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    // ***** 疑似ログイン解除 ******
    const pseudoLoginCancel = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }
      errorMessage.value = "";
      if (!pseudoAgCode.value) {
        // 疑似ログイン情報が設定されていない（疑似ログインしていない）場合は処理終了
        inputAgCode.value = "";
        return;
      }

      processingStore.isProcessing = true;

      try {
        // ローカルストレージから疑似ログイン情報を削除
        removePseudoData();

        pseudoAgCode.value = "";
        pseudoAgName.value = "";
        pseudoUserId.value = "";
        inputAgCode.value = "";

        outputDebugLogs("疑似ログイン解除");

        // ログイン時のAGコードとユーザーIDでグローバルナビや権限情報などを取得
        const error = await getLoginInfomation(
          agCode.value,
          userId.value,
          false
        );

        if (error) {
          formErrorMessage.value = error;
          return;
        } else {
          formErrorMessage.value = "";
        }

        // 画面をリロード
        location.reload();
      } finally {
        processingStore.isProcessing = false;
      }
    };

    // ***** AGセグメント登録 *****
    const agSegmentReg = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      outputDebugLogs("AGセグメント登録");

      // AGセグメント登録画面へ遷移
      router.push("/agsegment-reg");
    };

    // ***** ユーザー情報管理 *****
    const userMaintenance = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      outputDebugLogs("ユーザー情報管理");

      // AG一般ユーザー登録・変更へ遷移
      router.push("/aguser-maintenance");
    };

    /** 営業日切替 */
    const chengeBuisinessDate = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }
      errorMessage.value = "";
      // 営業日入力チェック
      if (!inputBusinessDays.value) {
        errorMessage.value = formatMessage(messages.ERR_0001, "営業日");
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        var systemDate = localStorage.getItem(
          AppConstants.SYSTEMDATE_SESSION_NAME
        );
        outputDebugLogs("システム日付:" + systemDate);

        var formattedDate = "";
        if (!inputBusinessDays.value) {
          return;
        }

        formattedDate = inputBusinessDays.value.replace(/-/g, "/");

        localStorage.setItem(
          AppConstants.BUSINESS_DAYS_SESSION_NAME,
          formattedDate
        );

        // 画面をリロード
        location.reload();
      } finally {
        processingStore.isProcessing = false;
      }
    };

    /** 営業日切替解除 */
    const clearBuisinessDate = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      try {
        localStorage.removeItem(AppConstants.BUSINESS_DAYS_SESSION_NAME);

        // 画面をリロード
        location.reload();
      } finally {
        processingStore.isProcessing = false;
      }
    };

    // ***********************
    // ***** 権限制御関連 *****
    // ***********************

    // AGセグメント登録の表示制御
    const isDispAgSegmentReg = computed(() => {
      const categoryId = ref<string | null>(null);
      categoryId.value = getCategoryIdByName(
        AppConstants.CATEGORY_NAME_AG_SEGMENT_TOUROKU
      );
      if (categoryId.value === null) {
        return false;
      }

      return getPermissionFlag(categoryId.value);
    });

    // AG一般ユーザー登録・編集の表示制御
    const isDispAgUserMaintenance = computed(() => {
      const categoryId = ref<string | null>(null);
      categoryId.value = getCategoryIdByName(
        AppConstants.CATEGORY_NAME_AG_USER_TOUROKU
      );
      if (categoryId.value === null) {
        return false;
      }

      return getPermissionFlag(categoryId.value);
    });

    // お知らせ登録の表示制御
    const isDispNoticeReg = computed(() => {
      const categoryId = ref<string | null>(null);
      categoryId.value = getCategoryIdByName(
        AppConstants.CATEGORY_NAME_OSHIRASE_TOUROKU
      );
      if (categoryId.value === null) {
        return false;
      }

      return getPermissionFlag(categoryId.value);
    });

    // システム管理の表示制御
    const isDispSystemMaintenance = computed(() => {
      if (
        isDispGlovalNaviKanri.value == true ||
        isDispIconMenuKanri.value == true ||
        isDispLoginPopupKanri.value == true ||
        isDispBannerKanri.value == true
      ) {
        return true;
      } else {
        return false;
      }
    });

    // 管理者権限リストから引数のカテゴリIDに対する利用権限を取得します
    function getPermissionFlag(categoryId: string): boolean {
      const item = categoryListData.value.find(
        (item) => item.categoryId === categoryId
      );
      return item ? item.parmitionFlg : false;
    }

    // グローバルナビ管理の表示制御
    const isDispGlovalNaviKanri = computed(() => {
      const categoryId = ref<string | null>(null);
      categoryId.value = getCategoryIdByName(
        AppConstants.CATEGORY_NAME_GLOVALNAVI_KANRI
      );

      if (categoryId.value === null) {
        return false;
      }

      return getPermissionFlag(categoryId.value);
    });

    // アイコンメニュー管理の表示制御
    const isDispIconMenuKanri = computed(() => {
      const categoryId = ref<string | null>(null);
      categoryId.value = getCategoryIdByName(
        AppConstants.CATEGORY_NAME_ICONMENU_KANRI
      );

      if (categoryId.value === null) {
        return false;
      }

      return getPermissionFlag(categoryId.value);
    });

    // ログイン時ポップアップ管理の表示制御
    const isDispLoginPopupKanri = computed(() => {
      const categoryId = ref<string | null>(null);
      categoryId.value = getCategoryIdByName(
        AppConstants.CATEGORY_NAME_LOGIN_POPUP_TOUROKU
      );

      if (categoryId.value === null) {
        return false;
      }

      return getPermissionFlag(categoryId.value);
    });

    // バナー登録の表示制御
    const isDispBannerKanri = computed(() => {
      const categoryId = ref<string | null>(null);
      categoryId.value = getCategoryIdByName(
        AppConstants.CATEGORY_NAME_BANNER_KANRI
      );

      if (categoryId.value === null) {
        return false;
      }

      return getPermissionFlag(categoryId.value);
    });

    // ワンストップガイド管理の表示制御
    const isDispOneStopGideKanri = computed(() => {
      if (
        isDispFAQTouroku.value == true ||
        isDispShinseisyoTouroku.value == true ||
        isDispTeiansyoTouroku.value == true ||
        isDispManualTouroku.value == true
      ) {
        return true;
      } else {
        return false;
      }
    });

    // FAQ登録の表示制御
    const isDispFAQTouroku = computed(() => {
      const categoryId = ref<string | null>(null);
      categoryId.value = getCategoryIdByName(
        AppConstants.CATEGORY_NAME_FAQ_TOUROKU
      );

      if (categoryId.value === null) {
        return false;
      }

      return getPermissionFlag(categoryId.value);
    });

    // 申請書登録の表示制御
    const isDispShinseisyoTouroku = computed(() => {
      const categoryId = ref<string | null>(null);
      categoryId.value = getCategoryIdByName(
        AppConstants.CATEGORY_NAME_SHINSEISYO_TOUROKU
      );

      if (categoryId.value === null) {
        return false;
      }

      return getPermissionFlag(categoryId.value);
    });

    // 提案書登録の表示制御
    const isDispTeiansyoTouroku = computed(() => {
      const categoryId = ref<string | null>(null);
      categoryId.value = getCategoryIdByName(
        AppConstants.CATEGORY_NAME_TEIANSYO_TOUROKU
      );

      if (categoryId.value === null) {
        return false;
      }

      return getPermissionFlag(categoryId.value);
    });

    // 帳票・マニュアル登録の表示制御
    const isDispManualTouroku = computed(() => {
      const categoryId = ref<string | null>(null);
      categoryId.value = getCategoryIdByName(
        AppConstants.CATEGORY_NAME_MANUAL_TOUROKU
      );

      if (categoryId.value === null) {
        return false;
      }

      return getPermissionFlag(categoryId.value);
    });

    // スキルアップ管理の表示制御
    const isDispSkilupKanri = computed(() => {
      if (
        isDispSkilupTouroku.value == true ||
        isDispEventTouroku.value == true ||
        isDispEventEntryDL.value == true
      ) {
        return true;
      } else {
        return false;
      }
    });

    // スキルアップ登録の表示制御
    const isDispSkilupTouroku = computed(() => {
      const categoryId = ref<string | null>(null);
      categoryId.value = getCategoryIdByName(
        AppConstants.CATEGORY_NAME_SKILUP_TOUROKU
      );

      if (categoryId.value === null) {
        return false;
      }

      return getPermissionFlag(categoryId.value);
    });

    // イベント登録の表示制御
    const isDispEventTouroku = computed(() => {
      const categoryId = ref<string | null>(null);
      categoryId.value = getCategoryIdByName(
        AppConstants.CATEGORY_NAME_EVENT_TOUROKU
      );

      if (categoryId.value === null) {
        return false;
      }

      return getPermissionFlag(categoryId.value);
    });

    // イベント申込み情報ダウンロードの表示制御
    const isDispEventEntryDL = computed(() => {
      const categoryId = ref<string | null>(null);
      categoryId.value = getCategoryIdByName(
        AppConstants.CATEGORY_NAME_EVENT_ENTRY_DL
      );

      if (categoryId.value === null) {
        return false;
      }

      return getPermissionFlag(categoryId.value);
    });

    // ************************
    // 各種処理
    // ************************

    // ***** お知らせ登録 *****
    const infoReg = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      outputDebugLogs("お知らせ登録");

      // お知らせのカテゴリIDを取得
      const regCategoryId = getCategoryIdByName(
        AppConstants.CATEGORY_NAME_INFO
      );
      // お知らせ登録へ遷移
      router.push({
        path: "/notification-reg",
        query: {
          categoryId: regCategoryId,
        },
      });
    };

    // ***** 管理者からのお知らせ登録 *****
    const adminInfoReg = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      outputDebugLogs("お知らせ登録");

      // 管理者からのお知らせのカテゴリIDを取得
      const regCategoryId = getCategoryIdByName(
        AppConstants.CATEGORY_NAME_ADMIN_INFO
      );
      // 管理者からのお知らせ登録へ遷移
      router.push({
        path: "/kanrisya-notification-reg",
        query: {
          categoryId: regCategoryId,
        },
      });
    };

    /** グローバルナビ管理 */
    const globalNaviKanri = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      outputDebugLogs("グローバルナビ管理");

      // グローバルナビ管理一覧へ遷移
      router.push({
        path: "/glovalnavi-kanri-list",
      });
    };

    /** アイコンメニュー管理 */
    const iconMenuKanri = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      outputDebugLogs("アイコンメニュー管理");

      // アイコンメニュー管理へ遷移
      router.push({
        path: "/iconmenu-kanri-list",
      });
    };

    /** バナー登録 */
    const bannerTouroku = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      outputDebugLogs("バナー登録");

      // バナー登録へ遷移
      router.push({
        path: "/banner-touroku-list",
      });
    };

    /** ログイン時ポップアップ登録 */
    const loginPopupTouroku = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      outputDebugLogs("ログイン時ポップアップ登録");

      // ログイン時ポップアップ登録へ遷移
      router.push({
        path: "login-popup-list",
      });
    };

    /** FAQ登録 */
    const faqReg = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      outputDebugLogs("FAQ登録");

      // FAQ登録のカテゴリIDを取得
      const regCategoryId = getCategoryIdByName(AppConstants.CATEGORY_NAME_FAQ);
      // FAQ登録へ遷移
      router.push({
        path: "/notification-reg",
        query: {
          categoryId: regCategoryId,
        },
      });
    };

    /** 申請書登録 */
    const shinseisyoReg = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      outputDebugLogs("申請書登録");

      // 申請書登録のカテゴリIDを取得
      const regCategoryId = getCategoryIdByName(
        AppConstants.CATEGORY_NAME_SHINSEISYO
      );
      // 申請書登録へ遷移
      router.push({
        path: "/notification-reg",
        query: {
          categoryId: regCategoryId,
        },
      });
    };

    /** 提案書登録 */
    const teiansyoReg = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      outputDebugLogs("提案書登録");

      // 提案書のカテゴリIDを取得
      const regCategoryId = getCategoryIdByName(
        AppConstants.CATEGORY_NAME_TEIANSYO
      );
      // 提案書登録へ遷移
      router.push({
        path: "/notification-reg",
        query: {
          categoryId: regCategoryId,
        },
      });
    };

    /** 帳票・マニュアル登録 */
    const manualReg = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      outputDebugLogs("帳票・マニュアル登録");

      // 帳票・マニュアルのカテゴリIDを取得
      const regCategoryId = getCategoryIdByName(
        AppConstants.CATEGORY_NAME_TYOHYO_MANUAL
      );
      // 帳票・マニュアル登録へ遷移
      router.push({
        path: "/notification-reg",
        query: {
          categoryId: regCategoryId,
        },
      });
    };

    /** ワンストップガイド管理 */
    const oneStopGideKanri = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      outputDebugLogs("ワンストップガイド管理");

      // 帳票・マニュアル登録へ遷移
      router.push({
        path: "/one-stop-gide_kanri",
      });
    };

    /** スキルアップ登録 */
    const skilupReg = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      outputDebugLogs("スキルアップ登録");

      // スキルアップのカテゴリIDを取得
      const regCategoryId = getCategoryIdByName(
        AppConstants.CATEGORY_NAME_SKILLUP
      );

      // スキルアップ登録へ遷移
      router.push({
        path: "/skilup-touroku",
        query: {
          categoryId: regCategoryId,
        },
      });
    };

    /** イベント登録 */
    const eventReg = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      outputDebugLogs("イベント登録");

      // スキルアップのカテゴリIDを取得
      const regCategoryId = getCategoryIdByName(
        AppConstants.CATEGORY_NAME_EVENT
      );

      // イベント登録へ遷移
      router.push({
        path: "/event-touroku",
        query: {
          categoryId: regCategoryId,
        },
      });
    };

    /** イベント申込み情報ダウンロード */
    const eventEntryDL = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      outputDebugLogs("イベント申込み情報ダウンロード");

      // イベント申込み情報ダウンロードへ遷移
      router.push({
        path: "/event-entry-dl",
      });
    };

    return {
      pseudoLogin,
      pseudoLoginCancel,
      inputAgCode,
      pseudoAgCode,
      pseudoAgName,
      pseudoUserId,
      errorMessage,
      formErrorMessage,
      agSegmentReg,
      userMaintenance,
      infoReg,
      isKaunetAdmin,
      isDispAgSegmentReg,
      isDispAgUserMaintenance,
      isDispNoticeReg,
      adminInfoReg,
      isDispSystemMaintenance,
      isDispGlovalNaviKanri,
      isDispIconMenuKanri,
      isDispLoginPopupKanri,
      isDispBannerKanri,
      isDispOneStopGideKanri,
      isDispFAQTouroku,
      isDispShinseisyoTouroku,
      isDispTeiansyoTouroku,
      isDispManualTouroku,
      isDispSkilupKanri,
      isDispSkilupTouroku,
      isDispEventTouroku,
      isDispEventEntryDL,
      globalNaviKanri,
      iconMenuKanri,
      bannerTouroku,
      loginPopupTouroku,
      faqReg,
      shinseisyoReg,
      teiansyoReg,
      manualReg,
      skilupReg,
      eventReg,
      eventEntryDL,
      inputBusinessDays,
      chengeBuisinessDate,
      clearBuisinessDate,
      oneStopGideKanri,
      AppConstants,
      isDataFetched,
      isLoading,
    };
  },
});
</script>

<style scoped>
fieldset.agent-buttons {
  position: relative; /* 相対位置を指定 */
  border: 1px solid #292929; /* 枠線のスタイル */
  padding: 20px; /* 内側の余白 */
  margin-top: 30px; /* 上部の余白 */
  top: 20px;
  display: flex; /* フレックスボックスでボタンを横並びにする */
  flex-wrap: nowrap; /* ボタンが折り返されないようにする */
}

legend {
  position: absolute; /* 絶対位置を指定 */
  top: -15px; /* 上端から-10pxの位置に配置 */
  left: 20px; /* 左端から10pxの位置に配置 */
  padding: 0 5px; /* ラベルの左右のパディング */
  background: white; /* 背景色（フィールドセットの背景と同じ色にすると良い） */
  color: black; /* テキスト色 */
  border: none; /* 枠線なし */
  width: auto;
  font-size: 12pt;
}
.button1 {
  margin-left: 10px; /* 左のマージンを10pxに設定 */
}
.button2 {
  margin: 0 10px; /* 上下のマージンは0、左右のマージンを10pxに設定 */
  width: 220px;
  height: 50px;
  border-radius: 5px;
  white-space: normal; /* テキストの折り返しを許可 */
  line-height: 1.2; /* 行間を調整 */
  justify-content: center; /* 水平方向の中央揃え */
  align-items: center; /* 垂直方向の中央揃え */
}

.com_form_contet1 .columns {
  display: flex;
  justify-content: space-between; /* 列間のスペースを均等配置 */
  gap: 20px; /* 列の間隔 */
}

.com_form_contet1 .column {
  flex: 1; /* 各列が均等に広がる */
  max-width: 45%; /* 必要なら最大幅を設定 */
}

.agent-buttons {
  width: 100%; /* コンテンツを列の幅に合わせる */
}
</style>
